export default "__VITE_ASSET__e560863f__"